/**
 * Created by rastwe on 3/1/2017.
 */
import reduxImmutableStateInvariant from 'redux-immutable-state-invariant';
import {authenticationMiddleware} from '@ey/voltron-core';
import rootReducer from '../app/rootReducer';
import apiMiddleware from '../middlewares/api-middleware';
import config from '../auth/config';
import versionCheck from '../middlewares/version-check';
import {configureStore} from '@reduxjs/toolkit';
import envConfig from '@ey/voltron-config';
import {adobeAnalytics} from '@ey/voltron-analytics';

/**
 * Configures and creates a Redux store that includes all reducers and
 * the initial state of the application.
 * The devToolsExtension reference in the compose() call is the Chrome
 * implementation of the Redux development tool. Refer to:
 * https://chrome.google.com/webstore/detail/redux-devtools/lmhkpmbekcpmknklioeibfkpmmfibljd?hl=en
 * Note that the reduxImmutableStateInvariant middleware is needed only
 * in dev mode to prevent developers from modifying the state directly.
 * Doing so will produce an error.
 * Thunk is here to use for async operations like Ajax.
 * @param {Object} initialState - The initial state of your application.
 *      Particularly useful for server side rendering.
 * @return {*} A Redux Store instance
 */
export default function (initialState) {
	return configureStore({
		reducer: rootReducer,
		preloadedState: initialState,
		middleware: [
			authenticationMiddleware(config),
			apiMiddleware(config),
			adobeAnalytics.adobeAnalyticsMiddleware(envConfig.adobeAnalytics),
			versionCheck(config),
			typeof window !== 'undefined' && reduxImmutableStateInvariant()
		].filter(Boolean)
	});
}
